import React, { useState, useEffect } from 'react';
import '../App.css';
import Swal from 'sweetalert2';
import axiosInstance from '../api/axiosInstance';

function SpecialNotesModal({ isOpen, onClose, selectedDates, supervisors, onSaveSuccess }) {
  const [notes, setNotes] = useState({}); // { supervisorId: { type: '', remarks: '' } }
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (isOpen) {
      // 모달이 열릴 때마다 상태 초기화
      const initialNotes = {};
      supervisors.forEach(s => {
        initialNotes[s.id] = { type: '', remarks: '' };
      });
      setNotes(initialNotes);
      setSearchTerm(''); // 모달 열릴 때 검색어도 초기화
    }
  }, [isOpen, supervisors]);

  const handleNoteChange = (supervisorId, field, value) => {
    setNotes(prevNotes => ({
      ...prevNotes,
      [supervisorId]: {
        ...prevNotes[supervisorId],
        [field]: value
      }
    }));
  };

  const handleSaveNotes = async () => {
    const specialNotesToSave = [];
    for (const supervisorId in notes) {
      const note = notes[supervisorId];
      if (note.type && selectedDates.length > 0) {
        selectedDates.forEach(date => {
          specialNotesToSave.push({
            supervisorId: supervisorId,
            noteType: note.type,
            scheduledDate: date,
            remarks: note.remarks
          });
        });
      }
    }

    if (specialNotesToSave.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: '입력 오류',
        text: '등록할 특이사항이 없습니다. 유형을 선택해주세요.',
      });
      return;
    }

    try {
      await axiosInstance.post('/special-notes', specialNotesToSave);
      Swal.fire(
        '등록 완료!',
        '특이사항이 성공적으로 등록되었습니다.',
        'success'
      );
      onClose();
      onSaveSuccess(); // 성공 시 콜백 호출
    } catch (error) {
      console.error('Error saving special notes:', error);
      Swal.fire({
        icon: 'error',
        title: '오류',
        text: error.response?.data || '특이사항 등록 중 오류가 발생했습니다.',
      });
    }
  };

  if (!isOpen) return null;

  const filteredSupervisors = supervisors.filter(s =>
    s.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">×</button>
        <h2>{selectedDates.length > 1 ? `${selectedDates[0]} ~ ${selectedDates[selectedDates.length - 1]} 특이사항 등록` : `${selectedDates[0]} 특이사항 등록`}</h2>
        
        <input
          type="text"
          placeholder="감리원 검색..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control"
          style={{ marginBottom: '10px' }}
        />

        <div className="special-notes-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>감리원</th>
                <th>유형</th>
                <th>비고</th>
              </tr>
            </thead>
            <tbody>
              {filteredSupervisors.map(s => (
                <tr key={s.id}>
                  <td>{s.name}</td>
                  <td>
                    <select
                      value={notes[s.id]?.type || ''}
                      onChange={(e) => handleNoteChange(s.id, 'type', e.target.value)}
                      className="form-control"
                    >
                      <option value="">선택</option>
                      <option value="휴가">휴가</option>
                      <option value="병가">병가</option>
                      <option value="기타">기타</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      value={notes[s.id]?.remarks || ''}
                      onChange={(e) => handleNoteChange(s.id, 'remarks', e.target.value)}
                      className="form-control"
                      placeholder="비고 입력"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="form-actions">
            <button onClick={handleSaveNotes} className="submit-button">등록</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpecialNotesModal;